import { useState } from 'react'
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/24/outline'
import { ChatSessionInfo } from './types'

type ChatAssistantSessionInfoCardProps = {
    sessionInfo: ChatSessionInfo | null
    profileCount: number
    formatDateTimeValue: (value?: string | null) => string
}

export default function ChatAssistantSessionInfoCard({
    sessionInfo,
    profileCount,
    formatDateTimeValue
}: ChatAssistantSessionInfoCardProps) {
    const [isOpen, setIsOpen] = useState(false)
    if (!sessionInfo) {
        return null
    }

    return (
        <div className="rounded-2xl bg-white shadow-sm border border-gray-200">
            <button
                type="button"
                onClick={() => setIsOpen((current) => !current)}
                className="flex w-full items-center justify-between px-6 py-4 text-left"
                aria-expanded={isOpen}
            >
                <span className="text-sm font-semibold text-gray-900">Chat context</span>
                {isOpen ? (
                    <ChevronDownIcon className="h-5 w-5 text-gray-400" />
                ) : (
                    <ChevronRightIcon className="h-5 w-5 text-gray-400" />
                )}
            </button>
            {isOpen && (
                <div className="border-t border-gray-200 px-6 py-5">
                    <p className="text-sm text-gray-600">
                        Analysing{' '}
                        <span className="font-semibold text-gray-900">
                            {sessionInfo.itemCount.toLocaleString()}
                        </span>{' '}
                        items from{' '}
                        <span className="font-semibold text-gray-900">
                            {profileCount.toLocaleString()}
                        </span>{' '}
                        {profileCount === 1 ? 'profile' : 'profiles'} between{' '}
                        <span className="font-semibold text-gray-900">
                            {formatDateTimeValue(sessionInfo.earliest)}
                        </span>{' '}
                        and{' '}
                        <span className="font-semibold text-gray-900">
                            {formatDateTimeValue(sessionInfo.latest)}
                        </span>
                    </p>
                </div>
            )}
        </div>
    )
}
